import React from 'react';
import {
  FiUpload,
  FiDownload,
  FiDownloadCloud,
  FiUser,
  FiUsers,
  FiCalendar,
  FiCheck,
  FiFilePlus,
  FiShare2,
  FiPlusCircle,
  FiEdit,
  FiTrash,
  FiFile,
  FiArrowRight,
  FiArrowRightCircle,
  FiArrowLeft,
} from 'react-icons/fi';
import { TiArrowBackOutline } from 'react-icons/ti';
import { FaRegSave, FaPlus } from 'react-icons/fa';
import { GoArrowUpRight } from 'react-icons/go';
import classNames from '../../utility/classNames';

export default function IconButton({
  text,
  icon,
  style,
  type = 'button',
  handleClick,
  disabled,
  iconClasses = '',
  iconPosition = 'right', // left or right
  classes = '',
  srText,
}) {
  const renderIcon = () => {
    switch (icon) {
      case 'upload':
        return <FiUpload className="-ml-0.5 mr-2 h-4 w-4" aria-hidden="true" />;
      case 'download':
        return (
          <FiDownload className="-ml-0.5 mr-2 h-4 w-4" aria-hidden="true" />
        );
      case 'download-cloud':
        return (
          <FiDownloadCloud
            className="-ml-0.5 mr-2 h-4 w-4"
            aria-hidden="true"
          />
        );
      case 'user':
        return <FiUser className="-ml-0.5 mr-2 h-4 w-4" aria-hidden="true" />;
      case 'users':
        return <FiUsers className="-ml-0.5 mr-2 h-4 w-4" aria-hidden="true" />;
      case 'add':
        if (style === 'table') {
          return (
            <div className="aspect-1 bg-neutral-100 text-primary-500 group-hover:bg-primary-400 group-hover:text-white border-r border-neutral-300 flex items-center justify-center  px-2 rounded-l">
              <FiPlusCircle
                className={classNames(iconClasses ? iconClasses : 'h-6 w-6')}
                aria-hidden="true"
              />
            </div>
          );
        }
        return (
          <FiPlusCircle
            className={classNames(
              'mb-[0.1rem] mr-[0.2rem]',
              iconClasses ? iconClasses : 'h-4 w-4'
            )}
            aria-hidden="true"
          />
        );
      case 'edit':
        return (
          <FiEdit
            className={classNames(iconClasses || '-ml-0.5 mr-2 h-4 w-4')}
            aria-hidden="true"
          />
        );
      case 'delete':
        return (
          <FiTrash
            className={classNames(iconClasses || '-ml-0.5 mr-2 h-4 w-4')}
            aria-hidden="true"
          />
        );
      case 'calendar':
        return (
          <FiCalendar className="-ml-0.5 mr-2 h-4 w-4" aria-hidden="true" />
        );
      case 'check':
        return <FiCheck className="-ml-0.5 mr-2 h-4 w-4" aria-hidden="true" />;
      case 'newFile':
        return (
          <FiFilePlus className="-ml-0.5 mr-2 h-4 w-4" aria-hidden="true" />
        );
      case 'share':
        return <FiShare2 className="-ml-0.5 mr-2 h-4 w-4" aria-hidden="true" />;
      case 'file':
        return <FiFile className="-ml-0.5 mr-2 h-4 w-4" aria-hidden="true" />;
      case 'back':
        return (
          <TiArrowBackOutline
            className="-ml-0.5 mr-2 h-4 w-4"
            aria-hidden="true"
          />
        );
      case 'enter':
      case 'arrow-right':
        return (
          <FiArrowRight
            className={classNames(iconClasses || 'h-4 w-4')}
            aria-hidden="true"
          />
        );
      case 'arrow-left':
        return (
          <FiArrowLeft
            className={classNames(iconClasses || 'h-4 w-4')}
            aria-hidden="true"
          />
        );

      case 'next':
        return (
          <FiArrowRightCircle
            className="-ml-0.5 mr-2 h-4 w-4"
            aria-hidden="true"
          />
        );
      case 'plus':
        return (
          <FaPlus
            className={classNames(iconClasses || '')}
            aria-hidden="true"
          />
        );
      case 'arrow-top-right':
        return (
          <GoArrowUpRight
            className={classNames(iconClasses || '')}
            aria-hidden="true"
          />
        );
      case 'save':
        return <FaRegSave className="h-4 w-4" aria-hidden="true" />;
      default:
        return null;
    }
  };

  const renderClassNames = () => {
    let classesByStyle = '';

    switch (style) {
      case 'gray':
        classesByStyle =
          'transition inline-flex justify-center items-center px-3 py-2 m-1 border border-neutral-300 shadow-sm text-base font-medium rounded text-neutral-700 bg-white hover:bg-neutral-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary disabled:opacity-50 disabled:cursor-not-allowed';
        break;
      case 'secondary':
        classesByStyle =
          'transition inline-flex justify-center items-center px-3 py-2 m-1 border border-primary text-base font-medium rounded text-primary bg-neutral-50 hover:bg-primary-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary disabled:opacity-50 disabled:cursor-not-allowed';
        break;
      case 'table':
        classesByStyle =
          'inline-flex group justify-between items-center p-0 gap-2 pr-2 bg-white shadow m-0 text-base font-normal rounded text-primary-700 border border-neutral-300  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary disabled:opacity-50 disabled:cursor-not-allowed';
        break;
      case 'list':
        classesByStyle =
          'transition ml-1 inline-flex justify-center items-center px-2 py-2 m-1 -my-2 text-base font-medium rounded text-primary bg-neutral-50 bg-opacity-0 hover:bg-opacity-100 focus:outline-none focus:ring-2 focus:ring-primary disabled:opacity-50 disabled:cursor-not-allowed';
        break;
      case 'modal':
        classesByStyle =
          'transition inline-flex justify-center items-center px-1 py-1 text-base font-medium rounded text-neutral-700 hover:text-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary';
        break;
      //below are updated for the new design
      case 'outline':
        classesByStyle =
          'transition inline-flex justify-center items-center gap-2 py-1 px-2 w-[10.6rem] border border-neutral-200 text-md font-medium rounded-md text-primary hover:text-primary-500 hover:border-primary-500 focus:text-primary-500 focus:border-primary-500 focus:outline-none disabled:text-neutral-200 disabled:border-neutral-200 disabled:cursor-not-allowed';
        break;
      case 'outline-lg':
        classesByStyle =
          'transition inline-flex justify-center items-center gap-2 py-2 px-3 w-[10.6rem] border border-neutral-200 text-lg font-medium rounded-md text-primary hover:text-primary-500 hover:border-primary-500 focus:text-primary-500 focus:border-primary-500 focus:outline-none disabled:text-neutral-200 disabled:border-neutral-200 disabled:cursor-not-allowed';
        break;
      case 'primary-lg':
        classesByStyle =
          'transition inline-flex justify-center gap-2 items-center py-2 px-3 w-[10.6rem] border border-transparent text-lg font-medium rounded-md text-white bg-primary hover:bg-primary-500 focus:bg-primary-500 focus:outline-none disabled:bg-neutral-200 disabled:cursor-not-allowed';
        break;
      case 'primary':
      default:
        classesByStyle =
          'transition inline-flex justify-center gap-[4px] items-center py-1 px-2 w-[10.6rem] border border-transparent  text-md font-medium rounded-md text-white bg-primary hover:bg-primary-500 focus:bg-primary-500 focus:outline-none disabled:bg-neutral-200 disabled:cursor-not-allowed';
        break;
    }

    return classNames(classesByStyle, classes);
  };

  return (
    <button
      type={type}
      onClick={handleClick || undefined}
      className={renderClassNames()}
      disabled={disabled}
    >
      <span className="sr-only">{srText}</span>
      {iconPosition === 'left' && renderIcon()}
      <span className="button-content">{text}</span>
      {iconPosition === 'right' && renderIcon()}
    </button>
  );
}
